
import React from 'react'
import PropTypes from 'prop-types'
import { translate } from 'react-i18next'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableSortLabel from '@material-ui/core/TableSortLabel';

const SessionListHeader = ({ t, currentSort, sortDirection, sortFn }) => {
  const isActive = key => currentSort === key
  
  return (
    <TableHead>
      <TableRow>
        <TableCell>
          <TableSortLabel
            onClick={() => sortFn('caseId')}
            active={isActive('caseId')}
            direction={sortDirection}
          >{t('Case ID')}</TableSortLabel>
        </TableCell>
        <TableCell>
          <TableSortLabel
            onClick={() => sortFn('startTime')}
            active={isActive('startTime')}
            direction={sortDirection}
          >{t('Start Date')}</TableSortLabel><br />
          <TableSortLabel
            onClick={() => sortFn('endTime')}
            active={isActive('endTime')}
            direction={sortDirection}
          >{t('End Date')}</TableSortLabel>
        </TableCell>
        <TableCell>
          <TableSortLabel
            onClick={() => sortFn('isComplete')}
            active={isActive('isComplete')}
            direction={sortDirection}
          >{t('Complete')}</TableSortLabel>
        </TableCell>
        <TableCell>
          <TableSortLabel
            onClick={() => sortFn('lastScreenSaved')}
            active={isActive('lastScreenSaved')}
            direction={sortDirection}
          >{t('Last Page')}</TableSortLabel>
        </TableCell>
        <TableCell />
      </TableRow>
    </TableHead>
  )
}

SessionListHeader.propTypes = {
  t: PropTypes.func,
  columns: PropTypes.array,
  currentSort: PropTypes.string,
  sortDirection: PropTypes.string,
  sortFn: PropTypes.func
}

export default translate()(SessionListHeader)



// WEBPACK FOOTER //
// ./src/components/setup/recall-session/by-decision/SessionList/Desktop/SessionListHeader.js